import type { InjectionKey, Ref } from 'vue';

export const floatingRootKey: InjectionKey<Ref<HTMLElement | undefined>> = Symbol('floating-root');
